import { useSpriteUrl } from './spriteUrl'

export const IconTypesList = [
  'activity',
  'alert-circle',
  'archive',
  'alert-triangle',
  'bank',
  'calendar',
  'calendar-heart-01',
  'clipboard-minus',
  'clock',
  'sticker-square',
  'tag-01',
  'ticket-01',
  'align-center',
  'align-left',
  'align-right',
  'arrow-circle-broken-right',
  'arrow-narrow-left',
  'arrow-narrow-right',
  'asterisk',
  'bold',
  'book-open-01',
  'calendar-date',
  'check',
  'check-circle',
  'chevron-down',
  'chevron-right',
  'chevron-left',
  'copy-06',
  'dots-horizontal',
  'dots-vertical',
  'dot-circle',
  'dot-points',
  'dot',
  'download-cloud',
  'external-link',
  'eye',
  'fast-forward',
  'filter-lines',
  'flip-backwards',
  'flip-forwards',
  'funnel',
  'heading',
  'horizontal-rule',
  'info-circle',
  'italic',
  'line-chart-up',
  'location',
  'mail-01',
  'message-chat-square',
  'message-circle',
  'minus-circle',
  'ordered-list',
  'pencil-01',
  'pencil-02',
  'phone-call-01',
  'phone-off',
  'play-circle',
  'plus-circle',
  'plus',
  'refresh',
  'refresh-cw-04',
  'save-disk',
  'search-lg',
  'sort-ascending',
  'sort-descending',
  'send',
  'skip-back',
  'spinner-line',
  'trash-01',
  'trash',
  'underline',
  'user-square',
  'user-x',
  'user-01',
  'users-01',
  'community',
  'x-circle',
  'x-close',
  'menu-01',
  'log-out-01',
  'settings-01',
  'check-done-01',
  'announcement-02',
  'bar-chart-square-02',
  'download-cloud-02',
  'help-circle',
  'user-plus-01',
  'upload-cloud-02',
  'file-05',
  'columns-03',
  'table',
  'file-download-03',
  'calendar-check-01',
  'bell-01',
  'star-01',
  'map-01',
  'grid-01',
  'code-02',
  'code-browser',
  'globe-01',
  'navigation-pointer-01',
  'share-07',
] as const

export type IconTypes = (typeof IconTypesList)[number]
type IconProps = {
  type: IconTypes
  dataTestId?: string
  className?: string
  width?: number
  height?: number
  alt?: string
}

function Icon({ type, dataTestId, alt, ...props }: IconProps) {
  const sprite = useSpriteUrl()
  return (
    <svg
      data-testid={dataTestId ? `${dataTestId}-${type}` : type}
      width="24"
      height="24"
      // Remove parent viewBox to use the icon's own viewBox value in sprite.svg
      // viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={alt ? undefined : true}
      focusable="false"
      role={alt ? 'img' : undefined}
      {...props}
    >
      {alt && <title>{alt}</title>}
      <use xlinkHref={`${sprite}#${type}`} />
    </svg>
  )
}

export default Icon
